import React, { useState, useEffect } from 'react';
import { Form, Button, Modal, Col, Row, Tab, Tabs, Alert } from 'react-bootstrap';
import InbursaTemplateCrudService from '../../../services/InbursaTemplateCrudService';
import InputText from '../../../components/Forms/InputText';
import TabTemplateImages from './TabTemplateImages';

const sleep = (time) => new Promise((resolve) => setTimeout(resolve, time));

const ModalInbursaTemplate = ({ show, handleClose, dataItem, setRenderRows }) => {
  const isViewOrDelete = dataItem.typeView === 'View' || dataItem.typeView === 'Delete';

  const defaultTemplate = {
    name: '',
    enabled: false,
    description: '',
    enableChangeImage: true,
    selectedImages: {},
    selectedImageDefault: null,
    createdAt: new Date(),
    image: null,
    typeTemplate: 1,
  };

  const [tempImages, setTempImages] = useState([{ image: '/default/default.jpg', name: '', active: false }]);
  const [template, setTemplate] = useState(defaultTemplate);

  const [successMessage, setSuccessMessage] = useState(null);
  const [enableSaveChanges, setEnableSaveChanges] = useState(true);

  useEffect(() => {
    const fetchTemplate = async () => {
      if (show && dataItem.codeItem > 0) {
        try {
          const res = await InbursaTemplateCrudService.getTemplateById(dataItem.codeItem);
          const currentTemplate = res.data.data[0];

          setTemplate((prevTemplate) => ({
            ...prevTemplate,
            ...currentTemplate,
            image: currentTemplate.image,
          }));
          setTempImages(currentTemplate.templates);
        } catch (error) {
          console.error(error);
        }
      } else {
        setTemplate(defaultTemplate);
        setTempImages([{ image: '/default/default.jpg', name: '', active: false }]);
        setSuccessMessage(null);
        setEnableSaveChanges(true);
      }
    };

    fetchTemplate();
  }, [dataItem, show]);

  const formFieldsHandler = (event) => {
    const { name, value } = event.target;
    setTemplate((prevTemplate) => ({ ...prevTemplate, [name]: value }));
    setEnableSaveChanges(false);
  };

  const handleFileChange = (event) => {
    const randomName = Array(4)
      .fill(null)
      .map(() => Math.round(Math.random() * 16).toString(16))
      .join('');

    const file = event.target.files[0];
    const newFile = new File([file], randomName + '.jpg', { type: file.type });

    setTemplate((prevTemplate) => ({
      ...prevTemplate,
      image: `/inbursatemplates/${dataItem.codeItem}/${newFile.name}`,
      selectedImageDefault: newFile,
    }));
    setEnableSaveChanges(false);
  };

  const handleImageUpload = async () => {
    try {
      if (template.selectedImageDefault) {
        const formData = new FormData();
        formData.append('imageDefault', template.selectedImageDefault);

        await InbursaTemplateCrudService.uploadImageDefault(dataItem.codeItem, formData);
        console.log('Image uploaded successfully');
      }
    } catch (error) {
      console.error(error);
      if (error.response && error.response.status !== 200) {
        console.log(error);
      }
    }
  };

  const handleDelete = async () => {
    InbursaTemplateCrudService.deleteTemplate(dataItem.codeItem).then(res => {
      setSuccessMessage('success');
      sleep(1500).then(() => {
        handleClose();
        window.location.href = '/inbursa/templates';
      })
    }).catch(err => {
      console.log(err);
      if (err.response.status !== 200) {
        setSuccessMessage('danger');
      }
    });
  };

  const handleSubmit = async () => {
    try {
      await handleImageUpload();

      const updateTemplate = {
        name: template.name,
        enabled: template.enabled,
        description: template.description,
        image: template.image,
        templates: tempImages,
        createdAt: template.createdAt,
        typeTemplate: template.typeTemplate,
      };

      if (!dataItem.codeItem && dataItem.typeView === 'Create') {
        await InbursaTemplateCrudService.createTemplate(updateTemplate);
        await sleep(1500);
        handleClose();
        window.location.href = '/inbursa/templates';
      } else {
        await InbursaTemplateCrudService.updateTemplate(updateTemplate, dataItem.codeItem);
        setSuccessMessage('success');
        await sleep(1500);
        handleClose();
        window.location.href = '/inbursa/templates';
      }
    } catch (error) {
      console.error(error);
      if (error.response && error.response.status !== 200) {
        setSuccessMessage('danger');
      }
    }
  };

  let submitButton = !isViewOrDelete && (
    <Button type="button" disabled={enableSaveChanges} onClick={handleSubmit}>
      Save Changes
    </Button>
  );

  if (dataItem.typeView === 'Delete') {
    submitButton = (<><Button type="button" variant="danger" onClick={() => handleDelete()} >Delete</Button> {'  '}  {'  '} </>);
  }

  const closeButton = <Button variant="secondary" onClick={handleClose}> Close </Button>;

  return (
    <Modal size="lg" show={show} onHide={handleClose} backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{dataItem.typeView} {dataItem.nameView} Code {dataItem.codeItem}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
      {(dataItem.typeView === 'Delete') ? (<Alert key='danger' variant='danger'> ¿Seguro que quieres Eliminar el Template? </Alert>) : ""}
        <Tabs defaultActiveKey="main" id="justify-tab-example" className="mb-3" justify>
          <Tab eventKey="main" title="Data Template">
            <Row className="mb-3">
              <InputText defaultValue={template.name} label={'name'} handler={formFieldsHandler} conditionView={isViewOrDelete} width={'5'} />
              <Form.Group as={Col} md="4" key={'Enabled'}>
                <Form.Label>Enabled</Form.Label>
                <Form.Select
                  name="enabled"
                  onChange={isViewOrDelete ? null : formFieldsHandler}
                  readOnly={isViewOrDelete}
                  disabled={isViewOrDelete}
                  value={template.enabled}
                >
                  <option key='false' value='false' >False</option>
                  <option key='true' value='true' >True</option>
                </Form.Select>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <InputText defaultValue={template.description} label={'description'} handler={formFieldsHandler} conditionView={isViewOrDelete} width={'12'} />
            </Row>
            <Row className="mb-3" style={{ marginRight: '0px' }}>
              <Form.Group as={Col} md="6" key={'ImageDefault'}>
                {!isViewOrDelete && (
                  <>
                    <Form.Label>*Image</Form.Label>
                    <Form.Control
                      type="file"
                      accept="image/png,image/jpeg"
                      name={'imageDefault'}
                      placeholder="Select Image File"
                      onChange={isViewOrDelete ? null : handleFileChange}
                      readOnly={isViewOrDelete}
                      disabled={isViewOrDelete}
                    />
                  </>
                )}
              </Form.Group>
              <Form.Group as={Col} md="6" key={'typeTemplate'}>
                <Form.Label>Type</Form.Label>
                <Form.Select
                  name="typeTemplate"
                  onChange={isViewOrDelete ? null : formFieldsHandler}
                  readOnly={isViewOrDelete}
                  disabled={isViewOrDelete}
                  value={template.typeTemplate}
                >
                  <option key='1' value='1' >Templates</option>
                  <option key='2' value='2' >Banner</option>
                </Form.Select>
              </Form.Group>
            </Row>
            {submitButton}{'  '}{'  '}{closeButton}
          </Tab>
          {dataItem.codeItem > 0 && template.typeTemplate == 1 && (
            <Tab eventKey="templates" title="Templates">
              <TabTemplateImages tempImages={tempImages} setTempImages={setTempImages} setCloseButton={closeButton} codeMethod={dataItem.codeItem} isViewOrDelete={isViewOrDelete} handleClose={handleClose} enableChangeImage={template.enableChangeImage} setEnableChangeImage={(value) => setTemplate((prevTemplate) => ({ ...prevTemplate, enableChangeImage: value }))} selectedImages={template.selectedImages} setSelectedImages={(images) => setTemplate((prevTemplate) => ({ ...prevTemplate, selectedImages: images }))} setSuccessMessage={setSuccessMessage} />
            </Tab>
          )}
        </Tabs>
        {successMessage === 'danger' && (
          <Alert key="danger" variant="danger">
            ¡Template no actualizado!
          </Alert>
        )}
        {successMessage === 'success' && (
          <Alert key="success" variant="success">
            ¡Template Actualizado!
          </Alert>
        )}
        {successMessage === 'limit-exceeded' && (
          <Alert key="warning" variant="warning">
            ¡No puedes exceder el límite de 30 imágenes!
          </Alert>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ModalInbursaTemplate;
